import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import {
  FollowStatus,
  FollowListResponse,
} from 'types/interfaces/social';

export const followApi = createApi({
  reducerPath: 'followApi',
  baseQuery,
  tagTypes: ['FollowStatus', 'MyFollowing', 'MyFollowers'],
  endpoints: (builder) => ({
    getFollowStatus: builder.query<FollowStatus, number>({
      query: (userId) => ({
        url: `/users/${userId}/follow-status`,
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: (_result, _error, userId) => [
        { type: 'FollowStatus', id: userId },
      ],
    }),

    followUser: builder.mutation<{ following: true }, number>({
      query: (userId) => ({
        url: `/users/${userId}/follow`,
        method: 'POST',
        requiresAuth: true,
      }),
      invalidatesTags: (_result, _error, userId) => [
        { type: 'FollowStatus', id: userId },
        'MyFollowing',
      ],
    }),

    unfollowUser: builder.mutation<void, number>({
      query: (userId) => ({
        url: `/users/${userId}/follow`,
        method: 'DELETE',
        requiresAuth: true,
      }),
      invalidatesTags: (_result, _error, userId) => [
        { type: 'FollowStatus', id: userId },
        'MyFollowing',
      ],
    }),

    getMyFollowing: builder.query<FollowListResponse, void>({
      query: () => ({
        url: '/users/me/following',
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['MyFollowing'],
    }),

    getMyFollowers: builder.query<FollowListResponse, void>({
      query: () => ({
        url: '/users/me/followers',
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['MyFollowers'],
    }),
  }),
});

export const {
  useGetFollowStatusQuery,
  useFollowUserMutation,
  useUnfollowUserMutation,
  useGetMyFollowingQuery,
  useGetMyFollowersQuery,
} = followApi;
